module.exports = __webpack_public_path__ + "img/keyboard2_new.abe72ff1.jpeg";